export default __webpack_public_path__ + "static/media/logo-default-negative.8e882b1c.png";